import { render, staticRenderFns } from "./snapshot-detail.vue?vue&type=template&id=6b51fa7b"
import script from "./snapshot-detail.vue?vue&type=script&lang=js"
export * from "./snapshot-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports